import InnerComponent from '@Components/Production/ManualProductionEntry/ManualProductionEntryView';
import orgContainer from '@Components/AppContainer';

const ManualProductionEntryView = () => ((orgContainer(InnerComponent)));
export default ManualProductionEntryView;
